import BehaviorConfig from '@/models/app-config/behavior/behavior'
import AppId from '@/util/appid'
import LoginPageWithTab from '@spa/components/pages/auth/layout/tab/LoginPageWithTab.vue'
import SignupPageWithTab from '@spa/components/pages/auth/layout/tab/SignupPageWithTab.vue'
import LoginPageWithTitleSection from '@spa/components/pages/auth/layout/title-section/LoginPageWithTitleSection.vue'
import SignupPageWithTitleSection from '@spa/components/pages/auth/layout/title-section/SignupPageWithTitleSection.vue'
import ToSignup from '@spa/components/pages/auth/login/components/navigation/ToSignup.vue'
import Login from '@spa/components/pages/auth/login/Login.vue'
import LoginWithoutIcon from '@spa/components/pages/auth/login/LoginWithoutIcon.vue'
import LedianToLogin from '@spa/components/pages/auth/signup/with-sms/components/ledian/navigation/ToLogin.vue'
import {
  captionsForSignupContext
} from '@spa/components/pages/auth/signup/with-sms/components/note/default/signup-note-for-context'
import SignupWithSmsAuth from '@spa/components/pages/auth/signup/with-sms/SignupWithSmsAuth.vue'
import Signup from '@spa/components/pages/auth/signup/without-sms/Signup.vue'
import LedianCartLoginNote from '@spa/components/pages/cart/components/login/ledian/LedianCartLoginNote.vue'
import CartLogin from '@spa/components/pages/cart/Login.vue'
import CartLoginWithoutIcon from '@spa/components/pages/cart/LoginWithoutIcon.vue'
import CartSignup from '@spa/components/pages/cart/Signup.vue'
import PaidMembershipPlanNote from '@spa/components/pages/paid-membership/subscribe/components/note/PaidMembershipPlanNote.vue'
import { AuthViewDefinition } from '@spa/router/hooks/auth/view-definitions/types'
import Vue, { VueConstructor } from 'vue'

const empty = Vue.extend({
  template: '<div></div>',
})

type MinimumBehaviorDeps = Pick<BehaviorConfig, 'authentication'>
export function getAuthViewFor(behaviorConfig: MinimumBehaviorDeps): AuthViewDefinition {
  const signup = useSmsOnSignupOrElse(behaviorConfig)

  switch (AppId.getHostId()) {
    case AppId.getByHostName('ledian'):
      return {
        layout: {
          login: LoginPageWithTitleSection,
          signup: SignupPageWithTitleSection,
        },
        pages: {
          default: {
            login: {
              note: empty,
              another: ToSignup,
              form: LoginWithoutIcon,
            },
            signup: {
              note: captionsForSignupContext.forSingup,
              another: LedianToLogin,
              form: signup(Signup),
            },
          },
          cart: {
            login: {
              note: LedianCartLoginNote,
              another: ToSignup,
              form: CartLoginWithoutIcon,
            },
            signup: {
              note: captionsForSignupContext.forCartSignup,
              another: LedianToLogin,
              form: signup(CartSignup),
            },
          },
          paidMembership: {
            login: {
              note: PaidMembershipPlanNote,
              another: ToSignup,
              form: LoginWithoutIcon,
            },
            signup: {
              note: PaidMembershipPlanNote,
              another: LedianToLogin,
              form: signup(Signup),
            },
          },
        },
      }

    default:
      return {
        layout: {
          login: LoginPageWithTab,
          signup: SignupPageWithTab,
        },
        pages: {
          default: {
            login: {
              form: Login,
            },
            signup: {
              form: signup(Signup),
            },
          },
          cart: {
            login: {
              form: CartLogin,
            },
            signup: {
              form: signup(CartSignup),
            },
          },
          paidMembership: {
            login: {
              form: Login,
            },
            signup: {
              form: signup(Signup),
            },
          },
        },
      }
  }
}

const useSmsOnSignupOrElse =
  (behavior: Pick<BehaviorConfig, 'authentication'>) =>
    (otherwise: VueConstructor): VueConstructor =>
      behavior.authentication.sms.enabled
      ? SignupWithSmsAuth
      : otherwise
